<template>
  <el-upload
    class="qrcode-upload"
    ref="uploader"
    list-type="picture"
    accept="image/*"
    action="#"
    :auto-upload="false"
    :show-file-list="false"
    :on-change="onUpload"
  >
    <div class="qrcode-upload__wrapper" v-loading="loading">
      <YorkbbsImage class="qrcode-upload__image" :src="url" v-if="url"></YorkbbsImage>
      <i class="qrcode-upload__icon yk-qr-code" v-else></i>
      <span class="qrcode-upload__button">上传二维码</span>
    </div>
  </el-upload>
</template>
<script>
export default {
  name: 'FormUploadQrcode',
  props: {
    // 图片的URL
    url: String,
    // 最大图片大小，单位MB
    maxSize: { type: Number, default: 20 },
  },
  data() {
    return {
      // 图片上传状态
      loading: false,
    };
  },
  methods: {
    /**
     * 上传图片
     */
    async onUpload(file) {
      if (file.size > this.maxSize * 1024 * 1024) return this.$warning(`图片不能超过${this.maxSize}MB`);

      const formData = new FormData();
      formData.append('file', file.raw);
      this.loading = true;
      const { data } = await this.$axios.post('/media/v1/upload2', formData).finally(() => {
        this.loading = false;
      });

      this.$emit('update:url', data[0]);
    },
  },
};
</script>
<style lang="scss" scoped>
.qrcode-upload__wrapper {
  display: flex;
  align-items: center;
}
.qrcode-upload__image,
.qrcode-upload__icon {
  box-sizing: border-box;
  width: 58px;
  height: 58px;
  border-radius: 4px;
}
.qrcode-upload__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  color: var(--text-color-9);
  border: 1px solid #ccc;
}
.qrcode-upload__button {
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-color);
  text-decoration: underline;
  margin-left: 10px;
}
</style>
